/**
 * JWT Token Storage Utility
 *
 * Dual-token system:
 * - Access Token: Stored in memory (lost on page refresh, more secure)
 * - Refresh Token: Stored in localStorage (persists across sessions)
 */
const REFRESH_TOKEN_KEY = "refreshToken";

// In-memory storage for access token (not persisted)
let accessToken = null;

/**
 * Store the access token in memory
 * @param {string} token - The access token to store
 */
export const setAccessToken = (token) => {
	accessToken = token || null;
};

/**
 * Retrieve the access token from memory
 * @returns {string|null} The stored access token, or null if not present
 */
export const getAccessToken = () => accessToken;

/**
 * Remove the access token from memory
 */
export const clearAccessToken = () => {
	accessToken = null;
};

/**
 * Store the refresh token in localStorage
 * @param {string} token - The refresh token to store
 */
export const setRefreshToken = (token) => {
	if (token) {
		localStorage.setItem(REFRESH_TOKEN_KEY, token);
	}
};

/**
 * Retrieve the refresh token from localStorage
 * @returns {string|null} The stored refresh token, or null if not present
 */
export const getRefreshToken = () => localStorage.getItem(REFRESH_TOKEN_KEY);

/**
 * Remove the refresh token from localStorage
 */
export const clearRefreshToken = () => {
	localStorage.removeItem(REFRESH_TOKEN_KEY);
};

/**
 * Clear all tokens (both access and refresh)
 * Used during logout
 */
export const clearAllTokens = () => {
	clearAccessToken();
	clearRefreshToken();
};
